import React from 'react';
import { FormControlLabel, Radio, TextField } from '@material-ui/core';
import { $contains, $eq, $sw, $ew } from '../operators';
import { FilterForm, useFilterFormActions } from './filter-form';
import { mergeOverride } from './override-operator';
import { useMemo } from 'react';

export const StringFiltersDesignation = props => {
  return <FilterForm {...props} radioFilters={StringFilterFormItems} />;
};

function StringFilterFormItems({ setRadioFilter, radioValue, column, ...props }) {
  const { handleInputClick, form, getRadioValue } = useFilterFormActions(
    radioValue,
    setRadioFilter
  );
  const actualTitle = useMemo(() => column.render('Header'), [column.Header]);
  return (
    <>
      {[$contains, $eq,$sw, $ew].map(mergeOverride(column.overrideOperator)).map(e => (
        <React.Fragment key={e.key}>
          <FormControlLabel
            value={e.key}
            control={<Radio />}
            label={
              <TextField
                onClick={handleInputClick}
                inputRef={form.register}
                name={e.key}
                disabled={getRadioValue() !== e.key}
                variant="outlined"
                size="small"
                label={e.label}
              />
            }
          />
          <br />
        </React.Fragment>
      ))}
      <FormControlLabel
        value="false"
        control={<Radio />}
        label="Yes - Has a value."
        name="$empty"
        inputRef={form.register}
      />
      <FormControlLabel
        value="true"
        control={<Radio />}
        label="No - Does not have a value."
        name="$empty"
        inputRef={form.register}
      />
     
    </>
  );
}
